const $ = window.jQuery;
import 'jquery-match-height';

$(() => {
    const $cards = $('article.card');

    if (!$cards.length) {
        return;
    }

    //$cards.matchHeight({ byRow: false });

    // _.each($cards, table => {
    //     const $table = $(table);
    //     const instance = $table.attr('data-instance');
    //     const numRows = $table.attr('data-num-rows');
    //     for (let i = 0; i < numRows; i++) {
    //         $(
    //             `.pricing-table[data-instance="${instance}"] [data-row="${i}"]`,
    //         ).matchHeight({ byRow: false });
    //     }
    // });
});
